export const darkColors = {
  // === BACKGROUNDS (landing-page dark section system) ===
  bg: {
    primary: '#08080e',
    secondary: 'rgba(255, 255, 255, 0.045)',
    tertiary: 'rgba(255, 255, 255, 0.075)',
    surface: 'rgba(255, 255, 255, 0.11)',
    overlay: 'rgba(8, 8, 14, 0.86)',
  },

  // === ACCENT COLORS ===
  // Legacy key names are kept so existing components inherit the new landing palette.
  accent: {
    cyan: '#ff6b6b',
    cyanDim: '#b91c1c',
    cyanGlow: 'rgba(185, 28, 28, 0.22)',
    purple: '#c792ea',
    purpleDim: '#8e5eb8',
    purpleGlow: 'rgba(199, 146, 234, 0.14)',
    green: '#c3e88d',
    greenGlow: 'rgba(195, 232, 141, 0.16)',
    red: '#ff6b6b',
    redGlow: 'rgba(255, 107, 107, 0.14)',
    orange: '#f78c6c',
  },

  // === TEXT ===
  text: {
    primary: '#e8e8f0',
    secondary: 'rgba(255, 255, 255, 0.64)',
    muted: 'rgba(255, 255, 255, 0.38)',
    accent: '#ff6b6b',
  },

  // === BORDERS ===
  border: {
    subtle: 'rgba(255, 255, 255, 0.075)',
    default: 'rgba(255, 255, 255, 0.12)',
    strong: 'rgba(255, 255, 255, 0.18)',
    accent: 'rgba(255, 107, 107, 0.36)',
  },

  // === DIFFICULTY ===
  difficulty: {
    veryEasy: '#c3e88d',
    easy: '#9ccc65',
    medium: '#ffcb6b',
    hard: '#f78c6c',
    veryHard: '#ff6b6b',
  },

  // === RANKS ===
  rank: {
    novice: '#8a8a9a',
    explorer: '#c3e88d',
    master: '#82aaff',
    hacker: '#c792ea',
    sentinel: '#f78c6c',
    overlord: '#ffcb6b',
  },

  // === GRADIENTS ===
  gradient: {
    primary: 'linear-gradient(135deg, #ff6b6b 0%, #b91c1c 100%)',
    primarySubtle: 'linear-gradient(135deg, rgba(185,28,28,0.18) 0%, rgba(255,107,107,0.08) 100%)',
    card: 'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.015) 100%)',
    cyanFade: 'linear-gradient(180deg, rgba(185,28,28,0.16) 0%, transparent 100%)',
    heroOverlay: 'linear-gradient(180deg, rgba(8,8,14,0) 0%, rgba(8,8,14,0.6) 42%, #08080e 100%)',
  },
};

export const lightColors = {
  // === BACKGROUNDS ===
  bg: {
    primary: '#fafafa',
    secondary: 'rgba(255, 255, 255, 0.72)',
    tertiary: '#f0f0f0',
    surface: '#e8e8f0',
    overlay: 'rgba(250, 250, 250, 0.88)',
  },

  // === ACCENT COLORS ===
  accent: {
    cyan: '#b91c1c',
    cyanDim: '#8f1616',
    cyanGlow: 'rgba(185, 28, 28, 0.12)',
    purple: '#5b21b6',
    purpleDim: '#3f167f',
    purpleGlow: 'rgba(91, 33, 182, 0.09)',
    green: '#117a55',
    greenGlow: 'rgba(17, 122, 85, 0.12)',
    red: '#b91c1c',
    redGlow: 'rgba(185, 28, 28, 0.10)',
    orange: '#b45309',
  },

  // === TEXT ===
  text: {
    primary: '#111111',
    secondary: '#4a4a5a',
    muted: '#8a8a9a',
    accent: '#b91c1c',
  },

  // === BORDERS ===
  border: {
    subtle: 'rgba(0, 0, 0, 0.07)',
    default: 'rgba(0, 0, 0, 0.11)',
    strong: 'rgba(0, 0, 0, 0.18)',
    accent: 'rgba(185, 28, 28, 0.34)',
  },

  // === DIFFICULTY ===
  difficulty: {
    veryEasy: '#117a55',
    easy: '#4d7c0f',
    medium: '#b7791f',
    hard: '#c2410c',
    veryHard: '#b91c1c',
  },

  // === RANKS ===
  rank: {
    novice: '#8a8a9a',
    explorer: '#117a55',
    master: '#2563eb',
    hacker: '#5b21b6',
    sentinel: '#c2410c',
    overlord: '#b7791f',
  },

  // === GRADIENTS ===
  gradient: {
    primary: 'linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%)',
    primarySubtle: 'linear-gradient(135deg, rgba(185,28,28,0.10) 0%, rgba(12,12,20,0.035) 100%)',
    card: 'linear-gradient(180deg, rgba(255,255,255,0.84) 0%, rgba(255,255,255,0.58) 100%)',
    cyanFade: 'linear-gradient(180deg, rgba(185,28,28,0.10) 0%, transparent 100%)',
    heroOverlay: 'linear-gradient(180deg, rgba(250,250,250,0) 0%, rgba(250,250,250,0.72) 48%, #fafafa 100%)',
  },
};

// Default export kept for backward compatibility; prefer useColors() from ColorModeContext
export const colors = darkColors;
